import { Card, cn } from '@mlm/ui';
import type { AssistantPersonaDto } from '../../lib/assistant-api';

/**
 * Emoji card grid for starting a new chat: pick who you're talking to.
 * Personas are emoji-only in Phase 1 (image avatars come later).
 */
export function PersonaPicker({
  personas,
  onPick,
  disabled,
}: {
  personas: AssistantPersonaDto[];
  onPick: (personaId: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {personas.map((p) => (
        <Card
          key={p.id}
          role="button"
          tabIndex={0}
          aria-disabled={disabled}
          onClick={() => !disabled && onPick(p.id)}
          onKeyDown={(e) => {
            if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
              e.preventDefault();
              onPick(p.id);
            }
          }}
          className={cn(
            'flex cursor-pointer flex-col items-center gap-1.5 p-4 text-center transition-colors hover:border-o hover:bg-o-l/30',
            disabled && 'pointer-events-none opacity-60',
          )}
        >
          <span className="text-3xl" aria-hidden>
            {p.icon}
          </span>
          <span className="text-sm font-medium">{p.name}</span>
          <span className="text-xs leading-snug text-muted-foreground">{p.tagline}</span>
          {p.accountAware && (
            <span className="rounded-full bg-o-l px-2 py-0.5 text-[10px] font-medium text-o">
              Knows your account
            </span>
          )}
        </Card>
      ))}
    </div>
  );
}
